import { TableBodyCell, AvatarList, TableCellEmpty, UserAvatar } from '@pocketlaw/tetris';
import { TasksIds } from '../../../types';
export function AssigneeCell(props) {
    const { assignees = [] } = props;
    return (<TableBodyCell headers={TasksIds.assignee}>
      {assignees.length === 0 ? (<TableCellEmpty />) : (<AvatarList>
          {assignees.map((asignee) => (<UserAvatar key={asignee.id} title={asignee.user.name}/>))}
        </AvatarList>)}
    </TableBodyCell>);
}
